<section [attr.aria-labelledby]="'tab-image-gallery'" class="product-image">
    <!-- Here you should include the title of your carousel, it is MANDATORY because it is used in the aria-labelledby for A11Y-->
    <ng-content select="[id=tab-image-gallery]"></ng-content>

    <div [ngClass]="{ shown: product?.assets?.length > 1 }" class="product-image-gallery">
        <h-product-image-gallery
            [prefixTab]="'tab'"
            [maxVisibleImages]="defaultMaxVisibleImages"
            [product]="product"
            [isPersoProduct]="isPersoProduct"
            [currentIndex]="currentIndex"
            (currentIndexChange)="changeImage($event)">
        </h-product-image-gallery>

        <div @fadingAnimation class="show-more desktop-only" *ngIf="remainingImages > 1">
            <h-show-more
                (pressed)="handleZoomModal(true)"
                [moreNumber]="remainingImages"
                [openDialog]="true"
                [focusable]="true">
                <img
                    *ngIf="product?.assets?.length"
                    class="image-gallery-item"
                    i18n-alt="@@hermes.accessibility.show-all-images"
                    alt="{{ remainingImages }} more pictures, show all"
                    [attr.srcset]="
                        product.assets[maxVisibleImages]?.url
                            | productImageSeoUrl
                                : {
                                      slug: product.slug,
                                      imageSize: thumbnailSize,
                                      srcSet: true,
                                      templateType: product.templateType,
                                  }
                    "
                    [attr.src]="
                        product.assets[maxVisibleImages]?.url
                            | productImageSeoUrl
                                : {
                                      slug: product.slug,
                                      imageSize: thumbnailSize,
                                      templateType: product.templateType,
                                  }
                    " />
            </h-show-more>
        </div>
    </div>
    <div class="product-image-container" [@imageNoop]>
        <div
            *ngFor="let asset of product?.assets | slice : 0 : maxVisibleImages; index as idx; trackBy: trackByAsset"
            id="tabpanel{{ idx }}"
            [attr.role]="'tabpanel'"
            [attr.aria-labelledby]="prefixerLabelledBy(idx)"
            [class]="'image-tab ' + getMediaState(idx, asset)"
            [hidden]="currentIndex !== idx">
            <ng-container *ngIf="currentIndex === idx">
                <div class="product-image-wrapper" [@fadingAnimation]="getMediaState(idx)">
                    <button
                        *ngIf="asset?.type === 'image'; else video"
                        hZoomCursor
                        class="image-button"
                        (focus)="handleFocus()"
                        (keypress.enter)="handleZoomModal(true)"
                        (click)="handleZoomModal(true)"
                        [attr.aria-expanded]="'false'"
                        [attr.aria-haspopup]="'dialog'">
                        <span hSrOnlyNoSnippet i18n="@@hermes-product-page-translations.zoom-image">
                            zoom image, {{ productTitle }}
                        </span>

                        <!-- For assets, type == image -->
                        <ng-container *ngTemplateOutlet="mainImage; context: { $implicit: asset, imageUrl: asset.url }">
                        </ng-container>
                    </button>
                    <div id="virtual-try-on-button" *ngIf="isVtoEnabled && isImageLoaded">
                        <h-virtual-try-on-button [pageType]="'single product page'"></h-virtual-try-on-button>
                    </div>
                </div>

                <ng-template #mainImage let-imageUrl="imageUrl">
                    <!-- Display APW animations for APW product, not IE, and first asset -->
                    <div class="product-picture">
                        <ng-container
                            *ngIf="shouldDisplayApwAnimations && compositeAsset.length >= 1; else defaultPicture">
                            <h-apple-watch-image-animations
                                [@fadingAnimation]="getMediaState(idx)"
                                [compositeAsset]="compositeAsset">
                            </h-apple-watch-image-animations>
                        </ng-container>
                    </div>
                    <ng-template #defaultPicture>
                        <picture *ngIf="imageUrl">
                            <source
                                [attr.media]="'all'"
                                [attr.srcset]="
                                    imageUrl
                                        | productImageSeoUrl
                                            : {
                                                  slug: product.slug,
                                                  imageSize: this.size,
                                                  templateType: product.templateType,
                                              }
                                " />
                            <img
                                (load)="onImageLoaded()"
                                class="main-product-image"
                                [attr.src]="
                                    imageUrl
                                        | productImageSeoUrl
                                            : {
                                                  slug: product.slug,
                                                  imageSize: this.size,
                                                  templateType: product.templateType,
                                              }
                                "
                                hI18nAsset
                                [tag]="asset.tag"
                                [hI18nAttr]="'alt'"
                                [attr.fetchpriority]="currentIndex === 0 ? 'high' : 'auto'"
                                [imageTitle]="product.title"
                                [url]="asset.url"
                                alt="" />
                        </picture>
                    </ng-template>
                </ng-template>

                <ng-template #video>
                    <h-video
                        [posterUrl]="asset.posterUrl"
                        [videoName]="productTitle"
                        [preventFirstAutoplayEvent]="true"
                        [alwaysShowControls]="true"
                        [videoLoopMuteAutoplay]="true"
                        [isLightMode]="true"
                        [controlPosition]="isVtoEnabled ? highPosition : moderatePosition"
                        [mediaType]="'snackable_video'"
                        [videoUrl]="asset.url"
                        [videoRatio]="'1-1'">
                        <ng-container
                            *ngTemplateOutlet="mainImage; context: { $implicit: asset, imageUrl: asset.posterUrl }">
                        </ng-container>
                    </h-video>
                </ng-template>
            </ng-container>
        </div>
        <ng-content select="[id=virtual-try-on-button]"></ng-content>
    </div>
</section>
